<sn-drawer>
  <sn-drawer-header [title]="'shares.shareSettings' | t">
    <sn-icon-button icon="close" snDrawerClose snDrawerNavButton></sn-icon-button>
  </sn-drawer-header>

  <sn-drawer-content *ngIf="shares$ | async as shares">
    <ng-template [ngIf]="shares.length" [ngIfElse]="emptyList">
      <sn-sharing-list [items]="shares" [actions]="shareActions"></sn-sharing-list>
    </ng-template>

    <ng-template #emptyList>
      <sn-empty-state icon="cancel_presentation" [title]="'common.noResults' | t">
        {{ 'navigation.thisItemIsNotShared' | t }}
      </sn-empty-state>
    </ng-template>
  </sn-drawer-content>
</sn-drawer>

<sn-fab-button *ngIf="canAdd" position="bottomRight" (click)="addShare()">
  <sn-icon>add</sn-icon>
</sn-fab-button>
